import {v4 as uuid} from '../utils/uuid.js'
import { toKebab } from '../utils/convertCase.js';

export type ClassRootEl = string | HTMLElement | JQuery<any> | null | undefined;

export abstract class ClassBase {
	$el: JQuery<any>;
	id: string;

	constructor(el: ClassRootEl) {
		this.$el = $(el).eq(0);
		this.$el.data(`${toKebab(this.constructor.name)}-instance`, this);
		this.id = uuid()
	}
}